export default {
  logging: 'Connessione...',
  logCall: 'Registra chiamata',
  editLog: 'Modifica registro',
  select: 'Seleziona un record corrispondente',
  OnHold: 'In attesa',
  Ringing: 'Chiamata in corso',
  CallConnected: 'Chiamata connessa',
  unknownUser: 'Utente sconosciuto',
  unknownNumber: 'Anonimo',
  unavailable: 'Non disponibile',
  viewDetails: 'Visualizza dettagli',
};
